/** One character slot of a foe's codename. Spaces are gaps, not revealable letters. */
export type CodenameSlot =
  { kind: 'gap' } | { kind: 'letter'; char: string; letterIndex: number; revealed: boolean };

/** Splits a codename into slots, revealing the first `revealedCount` letters in reading order. */
export function codenameSlots(codename: string, revealedCount: number): CodenameSlot[] {
  let letterIndex = 0;
  return Array.from(codename).map((char) => {
    if (char === ' ') return { kind: 'gap' };
    const index = letterIndex++;
    return { kind: 'letter', char, letterIndex: index, revealed: index < revealedCount };
  });
}

export function letterCount(codename: string): number {
  return Array.from(codename).filter((char) => char !== ' ').length;
}
